import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SliderModule } from 'primeng/slider';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';

@Component({
  selector: 'app-slider',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    RadioButtonModule,
    HelpTextComponent,
    SliderModule,
  ],
  template: `
    <div class="tw-pb-1 tw-px-0.5">
      <small class="tw-font-bold">{{ label }} {{ required ? '*' : '' }}</small>
    </div>
    <div class="tw-flex tw-items-center tw-gap-5 tw-px-0.5 tw-w-full">
      <span class="tw-font-bold tw-text-[--sed-black-80-color] tw-cursor-default">{{
        min
      }}</span>
      <p-slider
        [formControl]="control"
        styleClass="tw-w-56"
        [min]="min"
        [max]="max"
        [ariaLabelledBy]="ariaLabelledBy"
        [ariaLabel]="ariaLabel || (!ariaLabelledBy && label ? label : null)"
      />
      <span class="tw-font-bold tw-text-[--sed-black-80-color] tw-cursor-default">{{
        max
      }}</span>
      <span
        class="tw-ml-3 tw-px-2 tw-py-0.5 tw-text-[20px] tw-rounded-md app-options-count tw-cursor-default"
      >
        {{ control.value }}
      </span>
    </div>
    <app-help-text [control]="control" [helpText]="helpText" />
  `,
  styles: ``,
})
export class SliderComponent extends BaseControlComponent {
  @Input({ required: true })
  min: number;

  @Input({ required: true })
  max: number;

  /** ID of the element that labels this slider (WCAG: use when label is rendered outside the control). */
  @Input()
  ariaLabelledBy: string;

  @Input()
  ariaLabel: string;
}
